var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5e28972-6580-4ec0-8d31-88ffe9f628a5",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b8d84d3a-7cf7-44e7-ba15-fc6c6f291ce2,.ea65a473-4dbc-4bde-9fe2-6303e70c8b8e{fill:none;}.aa351b7f-3feb-44eb-b3ff-1609d349b2d4,.b8d84d3a-7cf7-44e7-ba15-fc6c6f291ce2{stroke:#8e8e8e;}.aa351b7f-3feb-44eb-b3ff-1609d349b2d4,.b8d84d3a-7cf7-44e7-ba15-fc6c6f291ce2,.ea65a473-4dbc-4bde-9fe2-6303e70c8b8e{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.aa351b7f-3feb-44eb-b3ff-1609d349b2d4,.e11e867e-842f-4d19-bbf3-4367f2e62680{fill:#7f8080;}.a580a581-75cf-4089-b8a5-e624a5500639{fill:#fff;}.ea65a473-4dbc-4bde-9fe2-6303e70c8b8e{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "js") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b8d84d3a-7cf7-44e7-ba15-fc6c6f291ce2",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aa351b7f-3feb-44eb-b3ff-1609d349b2d4",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e11e867e-842f-4d19-bbf3-4367f2e62680",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a580a581-75cf-4089-b8a5-e624a5500639",
    d: "M51.5,62.2h1.3V69c0,2.7-1.3,3.5-3,3.5a2.9,2.9,0,0,1-1.4-.3l.2-1,1.1.2c1.1,0,1.8-.5,1.8-2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a580a581-75cf-4089-b8a5-e624a5500639",
    d: "M54.8,70.7a4.5,4.5,0,0,0,2.4.7c1.3,0,2.1-.7,2.1-1.7s-.6-1.5-1.9-2-2.7-1.5-2.7-2.9S56,62.1,58,62.1a4.2,4.2,0,0,1,2.2.5l-.4,1a3.6,3.6,0,0,0-1.9-.5A1.7,1.7,0,0,0,56,64.7c0,.9.6,1.4,2,1.9s2.6,1.5,2.6,3-1.2,2.9-3.5,2.9a4.7,4.7,0,0,1-2.6-.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ea65a473-4dbc-4bde-9fe2-6303e70c8b8e",
    d: "M41.8,34.9a2.7,2.7,0,0,0-2.1,2.8c0,5-.5,5.7-1.8,6.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ea65a473-4dbc-4bde-9fe2-6303e70c8b8e",
    d: "M41.8,52.6a2.6,2.6,0,0,1-2.1-2.8c0-5-.5-5.6-1.8-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ea65a473-4dbc-4bde-9fe2-6303e70c8b8e",
    d: "M52,52.6a2.6,2.6,0,0,0,2-2.8c0-5,.5-5.6,1.9-6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ea65a473-4dbc-4bde-9fe2-6303e70c8b8e",
    d: "M52,34.9a2.7,2.7,0,0,1,2,2.8c0,5,.5,5.7,1.9,6.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.131357219568e35163cf72bf6012b86d.svg";
export { ForwardRef as ReactComponent };